/**
 * Holds a page connection until its startup URL has been delivered by the host.
 *
 * A release is tied to the exact connection so a late acknowledgement from a
 * replaced SharedWorker port cannot connect the shell to a stale transport.
 */
export function createStartupUrlBarrier<T>(connect: (value: T) => void): {
  stage(value: T): void;
  release(value: T): void;
} {
  let pending: T | undefined;

  return {
    stage(value) {
      pending = value;
    },
    release(value) {
      if (pending !== value) {
        return;
      }
      pending = undefined;
      connect(value);
    },
  };
}
